import { philosopher } from "@/lib/fonts";
import React, { FC } from "react";
import WalletBalance from "./WalletBalance";
// import { Bell } from "lucide-react";

interface HomeHeaderProps {
  primaryText: string;
  secondaryText: string;
  breakLine: boolean;
}

const HomeHeader: FC<HomeHeaderProps> = ({
  primaryText,
  secondaryText,
  breakLine,
}) => {
  return (
    <header
      className={`px-4 pb-4 flex items-center justify-between ${philosopher.className}`}
    >
      {breakLine ? (
        <div>
          <p className="text-xl text-[#F2994A]">{primaryText}</p>
          <p className="text-2xl font-bold text-secondary -mt-1">
            {secondaryText}
          </p>
        </div>
      ) : (
        <div>
          <p className="text-2xl font-bold text-secondary -mt-1">
            <span className="text-[#F2994A] sm:inline">{primaryText}</span>{" "}
            {secondaryText}
          </p>
        </div>
      )}
      {/* <div className="flex shrink items-center gap-4"> */}
      {/* Coin Balance */}
      {/* <WalletBalance showCoins={false} /> */}

      {/* Notification Bell */}
      {/* <div className="p-2 rounded-full bg-[#F7EBDE]">
          <Bell className="text-gray-800" />
        </div> */}
      {/* </div> */}
    </header>
  );
};

export default HomeHeader;
